/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deep_Match_Ai_Disclaimer_TitleInputs */

const en_deep_match_ai_disclaimer_title = /** @type {(inputs: Deep_Match_Ai_Disclaimer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-assisted scoring`)
};

const de_deep_match_ai_disclaimer_title = /** @type {(inputs: Deep_Match_Ai_Disclaimer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-gestützte Bewertung`)
};

const fr_deep_match_ai_disclaimer_title = /** @type {(inputs: Deep_Match_Ai_Disclaimer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-assisted scoring`)
};

const es_deep_match_ai_disclaimer_title = /** @type {(inputs: Deep_Match_Ai_Disclaimer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-assisted scoring`)
};

const it_deep_match_ai_disclaimer_title = /** @type {(inputs: Deep_Match_Ai_Disclaimer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-assisted scoring`)
};

const nl_deep_match_ai_disclaimer_title = /** @type {(inputs: Deep_Match_Ai_Disclaimer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-assisted scoring`)
};

const pl_deep_match_ai_disclaimer_title = /** @type {(inputs: Deep_Match_Ai_Disclaimer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-assisted scoring`)
};

const fi_deep_match_ai_disclaimer_title = /** @type {(inputs: Deep_Match_Ai_Disclaimer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-assisted scoring`)
};

const da_deep_match_ai_disclaimer_title = /** @type {(inputs: Deep_Match_Ai_Disclaimer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-assisted scoring`)
};

const sv_deep_match_ai_disclaimer_title = /** @type {(inputs: Deep_Match_Ai_Disclaimer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-assisted scoring`)
};

/**
* | output |
* | --- |
* | "AI-assisted scoring" |
*
* @param {Deep_Match_Ai_Disclaimer_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const deep_match_ai_disclaimer_title = /** @type {((inputs?: Deep_Match_Ai_Disclaimer_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deep_Match_Ai_Disclaimer_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_deep_match_ai_disclaimer_title(inputs)
	if (locale === "fr") return fr_deep_match_ai_disclaimer_title(inputs)
	if (locale === "es") return es_deep_match_ai_disclaimer_title(inputs)
	if (locale === "it") return it_deep_match_ai_disclaimer_title(inputs)
	if (locale === "nl") return nl_deep_match_ai_disclaimer_title(inputs)
	if (locale === "pl") return pl_deep_match_ai_disclaimer_title(inputs)
	if (locale === "fi") return fi_deep_match_ai_disclaimer_title(inputs)
	if (locale === "da") return da_deep_match_ai_disclaimer_title(inputs)
	if (locale === "sv") return sv_deep_match_ai_disclaimer_title(inputs)
	return en_deep_match_ai_disclaimer_title(inputs)
});